import { formatDecimalPlace } from "common/formatters";
import Commodity from "./commodity";
import FuturesContractPrice from "features/futuresContracts/futuresContractPrice";

export default interface FuturesContract extends FuturesContractPrice {
    id: number;
    commodity: Commodity;
    cqgSymbol: string;
    expiration: Date;
    ricCode: string;
    maturityMonth: number;
    maturityYear: number;
}

export function formatFuturesPrice(price: number, isSettled: boolean): string {
    if (isSettled) return `${formatDecimalPlace(price)} s`;

    return formatDecimalPlace(price);
}